"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _xoomInOutView = _interopRequireDefault(require("./xoomInOutView"));
var _AboutTableExternalLink = _interopRequireDefault(require("./assets/About-Table-ExternalLink.svg"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AboutBody = function AboutBody(_ref) {
  var classes = _ref.classes,
    data = _ref.data,
    externalIconImage = _ref.externalIconImage;
  function boldText(text) {
    var boldedText = text.split('$$').map(function (splitedText) {
      if (splitedText != null && /\*(.*)\*/.test(splitedText)) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: classes.title
        }, splitedText.match(/\*(.*)\*/).pop());
      }
      return splitedText;
    });
    return boldedText;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 16,
    direction: "row",
    className: classes.aboutSection
  }, data.imageLocation === 'left' && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    lg: 3,
    md: 3,
    sm: 12,
    xs: 12,
    className: classes.imageSection
  }, data.image), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    lg: 9,
    md: 9,
    sm: 12,
    xs: 12,
    className: classes.contentSection
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.text
  }, data.content ? data.content.map(function (contentObj) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, contentObj.listWithNumbers && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.text
    }, /*#__PURE__*/_react.default.createElement("ol", null, contentObj.listWithNumbers.map(function (listObj) {
      return listObj.listWithAlpahbets ? /*#__PURE__*/
      // Alphetised sub ordered list
      _react.default.createElement("ol", {
        type: "a"
      }, listObj.listWithAlpahbets.map(function (listObj1) {
        return /*#__PURE__*/_react.default.createElement("li", null, listObj1.includes('$$') ? boldText(listObj1) : listObj1);
      })) : /*#__PURE__*/_react.default.createElement("li", null, listObj.includes('$$') ? boldText(listObj) : listObj);
    }))), contentObj.listWithAlpahbets && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.text
    }, /*#__PURE__*/_react.default.createElement("ol", {
      type: "a"
    }, contentObj.listWithAlpahbets.map(function (listObj) {
      return /*#__PURE__*/_react.default.createElement("li", null, listObj.includes('$$') ? boldText(listObj) : listObj);
    }))), contentObj.paragraph && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.text
    }, contentObj.paragraph.split('$$').map(function (splitedParagraph) {
      // Checking for regex ()[] pattern
      if (splitedParagraph != null && (/\[(.+)\]\((.+)\)/g.test(splitedParagraph) || /\((.+)\)\[(.+)\]/g.test(splitedParagraph))) {
        var title = splitedParagraph.match(/\[(.*)\]/).pop();
        var linkAttrs = splitedParagraph.match(/\((.*)\)/).pop().split(' ');
        var target = linkAttrs.find(function (link) {
          return link.includes('target:');
        });
        var url = linkAttrs.find(function (link) {
          return link.includes('url:');
        });
        var type = linkAttrs.find(function (link) {
          return link.includes('type:');
        }); // 0 : no img
        var href = splitedParagraph.match(/\((.*)\)/).pop();
        var link = /*#__PURE__*/_react.default.createElement(_core.Link, {
          title: title,
          target: target ? target.replace('target:', '') : '_blank',
          rel: "noreferrer",
          href: url ? url.replace('url:', '') : href && href.includes('@') ? "mailto:".concat(href) : href,
          color: "inherit",
          className: classes.link
        }, title);
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, link, type ? '' : /*#__PURE__*/_react.default.createElement("img", {
          src: externalIconImage
          // externalIconImage: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/common/images/logos/svgs/externalLinkIcon.svg',
          ,

          alt: "outbounnd web site icon",
          className: classes.linkIcon
        }));
      }
      // For email
      if (splitedParagraph != null && /@(.*)@/.test(splitedParagraph)) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: classes.email
        }, splitedParagraph.match(/@(.*)@/).pop());
      }
      // For sub headings
      if (splitedParagraph != null && /#(.*)#/.test(splitedParagraph)) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: classes.title
        }, splitedParagraph.match(/#(.*)#/).pop());
      }
      // For bolding inline words
      if (splitedParagraph != null && /\*(.*)\*/.test(splitedParagraph)) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: classes.title
        }, splitedParagraph.match(/\*(.*)\*/).pop());
      }
      // For downloading things
      if (splitedParagraph != null && /{(.*)}/.test(splitedParagraph)) {
        var downloadAttrs = splitedParagraph.match(/{(.*)}/).pop().split(',');
        var downloadLink = downloadAttrs.find(function (link) {
          return link.includes('link:');
        });
        var downloadTitle = downloadAttrs.find(function (link) {
          return link.includes('title:');
        });
        return /*#__PURE__*/_react.default.createElement(_core.Link, {
          target: "_blank",
          className: classes.link,
          href: downloadLink ? downloadLink.replace('link:', '') : ''
        }, downloadTitle ? downloadTitle.replace('title:', '') : '');
      }
      return splitedParagraph;
    })), contentObj.table && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.tableDiv
    }, /*#__PURE__*/_react.default.createElement("table", {
      className: classes.table
    }, /*#__PURE__*/_react.default.createElement("thead", {
      className: classes.tableHeader
    }, /*#__PURE__*/_react.default.createElement("tr", {
      className: classes.tableBodyRow
    }, /*#__PURE__*/_react.default.createElement("th", {
      className: classes.headerCell,
      "aria-label": "Index"
    }), contentObj.table[0].head.map(function (rowObj) {
      var outputHTML = /*#__PURE__*/_react.default.createElement("th", {
        className: classes.headerCell
      }, rowObj);
      if (rowObj != null && /{(.*)}/.test(rowObj)) {
        var thAttrs = rowObj.match(/{(.*)}/).pop().split('$$');
        var inlineStyleStr = thAttrs.find(function (thAttr) {
          return thAttr.includes('style:');
        }).replace('style:', '').replace(/'/g, '');
        var inlineStyleMap = {};
        inlineStyleStr.split(',').forEach(function (style) {
          // eslint-disable-next-line prefer-destructuring
          inlineStyleMap[style.split(':')[0]] = style.split(':')[1];
        });
        var text = thAttrs.find(function (thAttr) {
          return thAttr.includes('text:');
        });
        outputHTML = /*#__PURE__*/_react.default.createElement("th", {
          className: classes.headerCell,
          style: inlineStyleMap
        }, text.replace('text:', ''));
      }
      return outputHTML;
    }))), /*#__PURE__*/_react.default.createElement("tbody", null, contentObj.table[1].body.map(function (rowObj, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", {
        className: classes.tableBodyRow
      }, /*#__PURE__*/_react.default.createElement("td", {
        className: classes.tableCell
      }, index + 1), rowObj.row.map(function (rowValue) {
        var outputHTML = /*#__PURE__*/_react.default.createElement("td", {
          className: classes.tableCell
        }, rowValue);
        // add inline style
        if (rowValue != null && /{(.*)}/.test(rowValue)) {
          var thAttrs = rowValue.match(/{(.*)}/).pop().split('$$');
          var inlineStyleStr = thAttrs.find(function (thAttr) {
            return thAttr.includes('style:');
          }).replace('style:', '').replace(/'/g, '');
          var inlineStyleMap = {};
          inlineStyleStr.split(',').forEach(function (style) {
            // eslint-disable-next-line prefer-destructuring
            inlineStyleMap[style.split(':')[0]] = style.split(':')[1];
          });
          var text = thAttrs.find(function (thAttr) {
            return thAttr.includes('text:');
          });
          outputHTML = /*#__PURE__*/_react.default.createElement("td", {
            className: classes.tableCell,
            style: inlineStyleMap
          }, text.replace('text:', ''));
        }
        if (rowValue != null && (/\[(.+)\]\((.+)\)/g.test(rowValue) || /\((.+)\)\[(.+)\]/g.test(rowValue))) {
          var title = rowValue.match(/\[(.*)\]/).pop();
          var linkAttrs = rowValue.match(/\((.*)\)/).pop().split(' ');
          var target = linkAttrs.find(function (link) {
            return link.includes('target:');
          });
          var url = linkAttrs.find(function (link) {
            return link.includes('url:');
          });
          var type = linkAttrs.find(function (link) {
            return link.includes('type:');
          }); // 0 : no img
          var link = /*#__PURE__*/_react.default.createElement(_core.Link, {
            title: title,
            target: target ? target.replace('target:', '') : '_blank',
            rel: "noreferrer",
            href: url ? url.replace('url:', '') : rowValue.match(/\((.*)\)/).pop(),
            color: "inherit",
            className: classes.tableLink
          }, title);
          outputHTML = /*#__PURE__*/_react.default.createElement("td", {
            className: classes.tableCell
          }, link, type ? '' : /*#__PURE__*/_react.default.createElement("img", {
            src: _AboutTableExternalLink.default,
            alt: "outbounnd web site icon",
            className: classes.tablelinkIcon
          }));
        }
        return outputHTML;
      })));
    })))), /*#__PURE__*/_react.default.createElement("br", null));
  }) : '')), data.imageLocation === 'right' && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    lg: 3,
    md: 3,
    sm: 12,
    xs: 12,
    className: classes.imageSection
  }, data.image))), data.secondaryZoomImageTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.secondayTitle
  }, data.secondaryZoomImageTitle), data.secondaryImage && /*#__PURE__*/_react.default.createElement(_xoomInOutView.default, null, data.secondaryImageData));
};
var styles = function styles() {
  return {
    container: {
      margin: '16px auto 16px auto',
      color: '#000000',
      fontFamily: function fontFamily(props) {
        return props.data.fontFamily ? props.data.fontFamily : 'Nunito';
      },
      fontSize: '15px',
      lineHeight: '22px',
      maxWidth: '1440px'
    },
    maxWidthContainer: {
      margin: '0px auto 0px auto',
      maxWidth: '1440px'
    },
    secondayTitle: {
      display: 'block',
      textAlign: 'center',
      fontWeight: 'bold',
      marginBottom: '70px',
      color: '#033D6F',
      fontSize: '28px',
      fontFamily: 'Lato'
    },
    text: {
      // height: '476px',
      // width: '675px',
      color: '#000000',
      fontFamily: function fontFamily(props) {
        return props.data.fontFamily ? props.data.fontFamily : 'Nunito';
      },
      fontSize: '16px',
      lineHeight: function lineHeight(props) {
        return props.data.lineHeight ? props.data.lineHeight : '30px';
      }
    },
    title: function title(props) {
      return {
        color: props.titleColor,
        fontWeight: 'bold'
      };
    },
    email: function email(props) {
      return {
        color: props.linkColor,
        fontWeight: 'bold'
      };
    },
    contentSection: {
      padding: function padding(props) {
        return props.data.imageLocation === 'right' ? '8px 25px 8px 0px !important' : '8px 0px 8px 25px !important';
      },
      float: 'left'
    },
    imageSection: {
      float: 'left'
    },
    aboutSection: {
      padding: '60px 45px'
    },
    img: {
      width: '100%'
    },
    linkIcon: {
      width: '20px',
      verticalAlign: 'sub',
      margin: '0px 0px 0px 2px'
    },
    link: function link(props) {
      return {
        color: props.linkColor,
        '&:hover': {
          color: props.linkColor
        }
      };
    },
    tableDiv: {
      marginTop: '0px'
    },
    tablelinkIcon: {
      width: '15px',
      verticalAlign: 'sub',
      margin: '0px 0px 0px 2px'
    },
    tableLink: {
      fontWeight: 'bolder',
      textDecoration: 'underline'
    },
    table: {
      borderSpacing: '0',
      borderCollapse: 'collapse',
      fontSize: '12px',
      fontWeight: 'bold',
      letterSpacing: '0.025em',
      lineHeight: '30px',
      textAlign: 'left',
      width: '100%'
    },
    tableHeader: {
      fontFamily: function fontFamily(props) {
        return props.data.fontFamily ? props.data.fontFamily : 'Nunito';
      },
      color: '#194563',
      textTransform: 'uppercase'
    },
    tableBodyRow: {
      borderSpacing: '0',
      borderCollapse: 'collapse',
      color: '#3E7AAA'
    },
    tableCell: {
      fontFamily: function fontFamily(props) {
        return props.data.fontFamily ? props.data.fontFamily : 'Nunito';
      },
      fontSize: '14px',
      padding: '8px 15px 8px 0px',
      borderBottom: '0.66px solid #087CA5'
    },
    headerCell: {
      borderBottom: '4px solid #087CA5',
      borderSpacing: '0',
      borderCollapse: 'collapse',
      fontWeight: 'bolder'
    },
    MyCasesWizardStep4: {
      width: '600px'
    }
  };
};
AboutBody.defaultProps = {
  classes: {},
  data: {
    content: [],
    fontFamily: 'Nunito',
    lineHeight: '30px'
  },
  linkColor: '#0296C9',
  titleColor: '#0B3556',
  externalIconImage: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/common/images/logos/svgs/externalLinkIcon.svg'
};
var _default = (0, _core.withStyles)(styles)(AboutBody);
exports.default = _default;